"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var indicativeNumberStyles_1 = require("./indicativeNumberStyles");
var Translation_1 = require("../../../../common/components/presentation/Translation/Translation");
var IndicativeNumber = function (_a) {
    var value = _a.value, onClick = _a.onClick;
    var styles = indicativeNumberStyles_1.default();
    return (<core_1.Box onClick={onClick} className={styles.container} data-test={"common:scroll-to-" + value}>
      <core_1.Typography component="span" className={styles.labelText}>
        {value && <Translation_1.default id={value}/>}
      </core_1.Typography>
    </core_1.Box>);
};
exports.default = IndicativeNumber;
